<template>
  <a-drawer
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    :maskClosable="true"
    placement="right"
    @close="close"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="事件名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            type="text"
            :max-length="15"
            v-decorator="[
              'eventName',
              {
                rules: [
                  { required: true, message: '请输入事件名称,限制15个字' },
                ],
              },
            ]"
            placeholder="请输入事件名称"
          />
        </a-form-item>

        <a-form-item
          label="签到频率"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <j-dict-select-tag
            placeholder="请选择签到频率"
            v-decorator="[
              'eventSignFrequency',
              { rules: [{ required: true, message: '请选择签到频率' }] },
            ]"
            :triggerChange="true"
            dictCode="sign_type"
            @change="signFrequencyValue"
          />
        </a-form-item>
        <a-form-item
          v-if="isShowSignRule"
          label="签到规则"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-select
            v-decorator="[
              'eventSignContinuousFlag',
              { rules: [{ required: true, message: '请选择签到规则' }] },
            ]"
            placeholder="请选择签到规则"
          >
            <a-select-option
              v-for="(item, index) in signRuleOption"
              :value="item.value"
              :key="index"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </a-form-item>

        <a-form-item
          label="奖品是否相同"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group
            v-model="samePrizeFlag"
            @change="onChangeRadioValue"
            :disabled="disabled"
          >
            <a-radio :value="1">是</a-radio>
            <a-radio :value="0">否</a-radio>
          </a-radio-group>
        </a-form-item>

        <!--   eventRelevancePrizes     -->

        <a-form-item
          label="关联奖品"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          v-for="(item, index) in arr"
          :key="index"
        >
          <a-select
            v-model="relevancePrizes[index]"
            placeholder="请选择关联奖品"
          >
            <a-select-option
              v-for="(item, index) in prizesList"
              :value="item.id"
              :key="index"
              >{{ item.prizesName }}</a-select-option
            >
          </a-select>
        </a-form-item>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleOk" type="primary">提交</a-button>
    </div>
  </a-drawer>
</template>

<script>
import { postTag } from '@/api/manage';
import pick from 'lodash.pick';
// import { validateDuplicateValue } from '@/utils/util';
import JDate from '@/components/jeecg/JDate';
import moment from 'moment';
import { getAction } from '../../../../api/manage';
import JMultiSelectTag from '../../../../components/dict/JMultiSelectTag';

export default {
  name: 'SignEventManageModal',
  components: {
    JDate,
    JMultiSelectTag,
  },
  data() {
    return {
      prizesList: [], //奖品列表
      relevancePrizes: [], //选择的奖品列表
      samePrizeFlag: -1, //奖品是否相同标识
      signNum: '-1', //签到次数统计
      signRuleOption: [
        //签到规则
        {
          name: '连续签到',
          value: '1',
        },
        {
          name: '不限制',
          value: '2',
        },
      ],
      isShowRelevancePrizes: false, //关联奖品配置，默认隐藏
      isShowSignRule: false, //签到规则默认隐藏
      disabled: false, //默认不置灰
      arr: [], //默认数组长度为0

      headers: {
        authorization: 'authorization-text',
      },
      form: this.$form.createForm(this),
      title: '操作',
      width: 800,
      visible: false,
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      confirmLoading: false,
      validatorRules: {},
      url: {
        add: process.env.VUE_APP_CMS_MARKETING + '/event/sign/add',
        edit: process.env.VUE_APP_CMS_MARKETING + '/event/sign/edit',
      },
    };
  },
  created() {},
  methods: {
    moment,
    add() {
      this.edit({});
    },
    edit(record) {
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      if (this.model.id) {
        this.samePrizeFlag = this.model.eventSignPrizeSameFlag - 0;
        this.relevancePrizes = this.model.eventRelevancePrizes.split(',');
        if (this.samePrizeFlag == 1) {
          this.arr = [1];
        } else if (this.samePrizeFlag == 0 && this.model.eventSignFrequency == 1) {
          // this.arr = this.relevancePrizes;
          this.arr = [1, 2, 3, 4, 5];
        } else if (this.samePrizeFlag == 0 && this.model.eventSignFrequency == 3) {
          this.arr = [1, 2, 3];
        } else {
          this.arr = [];
        }
        this.signFrequencyInit(this.model.eventSignFrequency);
      } else {
        this.isShowSignRule = false;
        this.initConfig();
      }
      this.$nextTick(() => {
        this.form.setFieldsValue(
          pick(
            this.model,
            'eventName',
            'eventSignFrequency',
            'eventSignContinuousFlag',
            'eventSignPrizeSameFlag',
            'eventRelevancePrizes'
          )
        );
      });

      this.getPrizeList();
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    handleOk() {
      const that = this;
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let httpurl = '';
          if (!this.model.id) {
            httpurl += this.url.add;
          } else {
            httpurl += this.url.edit;
          }

          let formData = Object.assign(this.model, values);
          formData.eventSignPrizeSameFlag = this.samePrizeFlag.toString();
          formData.eventRelevancePrizes = this.relevancePrizes.toString();
          // if (this.samePrizeFlag == 1) {
          //   formData.eventRelevancePrizes = this.relevancePrizes[0].toString();
          // } else {
          //   formData.eventRelevancePrizes = this.relevancePrizes.toString();
          // }

          console.log('表单提交数据', formData);
          postTag(httpurl, formData)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            })
            .finally(() => {
              that.confirmLoading = false;
              that.close();
            });
        }
      });
    },
    handleCancel() {
      this.close();
    },
    popupCallback(row) {
      this.form.setFieldsValue(
        pick(
          row,
          'eventName',
          'eventSignFrequency',
          'eventSignContinuousFlag',
          'eventSignPrizeSameFlag',
          'eventRelevancePrizes'
        )
      );
    },

    /**获取奖品列表*/
    getPrizeList() {
      let getUrl =
        process.env.VUE_APP_GATEWAY_URL +
        process.env.VUE_APP_CMS_MARKETING +
        '/market/prize/getPrizeList';
      getAction(getUrl, {}).then((res) => {
        if (res.success) {
          this.prizesList = res.result;
        }
      });
    },

    changeSamePrizeFlag(checked) {
      this.samePrizeFlag = checked;
    },

    //单选按钮事件逻辑
    onChangeRadioValue(e) {
      this.relevancePrizes = []
      //console.log(e.target.value);
      //判断选择的签到频率
      const num = this.signNum;
      if (num === '-1') {
        this.arr = [];
        this.$message.warning('请选择签到频率');
      } else {
        if (num === '0') {
          //每天均可签到
          this.samePrizeFlag = 1; //默认奖品相同
          this.disabled = true; //设置不可选状态
          this.arr = [1];
        } else if (num === '3') {
          //每周3次
          if (e.target.value === 1) {
            this.samePrizeFlag = 1; //默认奖品相同
            //奖品相同
            this.arr = [1];
          } else {
            //奖品不同
            this.arr = [1, 2, 3];
          }
        } else if (num === '5') {
          //每周5次
          if (e.target.value === 1) {
            this.samePrizeFlag = 1; //默认奖品相同
            //奖品相同
            this.arr = [1];
          } else if (e.target.value === 0) {
            //奖品不同
            this.arr = [1, 2, 3, 4, 5];
          } else {
            this.arr = [];
          }
        }
      }
    },

    //签到频率事件逻辑
    signFrequencyValue(e) {
      if (e === '1') {
        //每周5次
        this.signNum = '5';
        this.isShowSignRule = true;
        this.initConfig();
      } else if (e === '2') {
        //每天均可签到
        this.signNum = '0';
        this.isShowSignRule = false; //隐藏签到规则
        this.onChangeRadioValue('-1');
      } else if (e === '3') {
        //每周3次
        this.signNum = '3';
        this.isShowSignRule = true;
        this.initConfig();
      } else {
        this.isShowSignRule = false; //默认隐藏
        this.signNum = '-1';
        this.initConfig();
      }
    },

    initConfig() {
      this.disabled = false; //单选按钮是否可选标识
      this.samePrizeFlag = '-1'; //奖品是否相同
      this.arr = []; //关联奖品配置数组
      this.relevancePrizes = []; //选择的关联奖品
    },

    signFrequencyInit(e) {
      if (e === '1') {
        //每周5次
        this.signNum = '5';
        this.isShowSignRule = true;
        this.disabled = false; //单选按钮是否可选标识
        //this.samePrizeFlag = '-1' //奖品是否相同
      } else if (e === '2') {
        //每天
        this.signNum = '0';
        this.isShowSignRule = false; //隐藏签到规则
        this.disabled = true; //单选按钮是否可选标识
        //this.onChangeRadioValue('-1');
      } else if (e === '3') {
        //每周3次
        this.isShowSignRule = true;
        this.signNum = '3';
        this.disabled = false; //单选按钮是否可选标识
        //this.samePrizeFlag = '-1' //奖品是否相同
      }
    },
  },
};
</script>
